import React, { useContext } from "react";
import { DatePicker, Input } from "antd";
import { FormControl } from "react-bootstrap";
import moment from "moment";

import "antd/dist/antd.css";
import SecurityUtil from "../../../utils/SecurityUtils";
import { AppContext } from "../../domain/App/AppContext";
import { constants } from "../../../utils/Constants";

const { RangePicker } = DatePicker;

const { Search } = Input;

const DATE_FORMAT = constants.DATE_FORMAT;

const SubmitControl = props => {
  const {
    onChange,
    type,
    validationRule,
    value,
    controlId,
    processes,
    partyId
  } = props;
  const validate = validationRule && validationRule.validate;
  const isRequired = validationRule && validationRule.required;
  const userHasAnyOfProcessesOrSameParty = SecurityUtil.userHasAnyOfProcessesOrSameParty(
    processes,
    partyId
  );

  let isValid;
  let isInvalid;

  if (props.valid !== undefined) {
    if (props.valid) {
      isValid = true;
    } else {
      isInvalid = true;
    }
  }

  if (validate) {
    if (validate(props.value)) {
      isValid = true;
    } else {
      isInvalid = true;
    }
  }

  const disableable =
    props.disableable === undefined ? true : props.disableable;

  const inProgress = useContext(AppContext).promiseInProgress;
  const afInput = useContext(AppContext).afInput;

  if (type === "date") {
    const error = (isRequired && !value) || isInvalid;

    return (
      <DatePicker
        className={error ? "error" : "valid"}
        disabled={
          disableable &&
          (props.disabled || inProgress || !userHasAnyOfProcessesOrSameParty)
        }
        placeholder={props.placeholder}
        value={value && moment(new Date(value), DATE_FORMAT)}
        onChange={e =>
          onChange &&
          onChange({
            target: { id: controlId, value: e && e.format(DATE_FORMAT) }
          })
        }
      />
    );
  } else if (type === "dateRange") {
    const error = (isRequired && !(value && value.dateFrom)) || isInvalid;

    return (
      <RangePicker
        allowEmpty={[false, true]}
        separator="~"
        className={error ? "error" : "valid"}
        disabled={
          disableable &&
          (props.disabled ||
            inProgress ||
            !userHasAnyOfProcessesOrSameParty ||
            props.readOnly)
        }
        placeholder={props.placeholder}
        value={[
          value &&
            value.dateFrom &&
            moment(new Date(value.dateFrom), DATE_FORMAT),
          value && value.dateTo && moment(new Date(value.dateTo), DATE_FORMAT)
        ]}
        onChange={e => {
          const dateFrom = e ? e[0] && e[0].format(DATE_FORMAT) : undefined;
          const dateTo = e ? e[1] && e[1].format(DATE_FORMAT) : undefined;
          onChange &&
            onChange({
              target: {
                id: controlId,
                value: { dateFrom: dateFrom, dateTo: dateTo }
              }
            });
        }}
      />
    );
  } else if (type === "search") {
    return (
      <Search
        disabled={disableable && (props.disabled || inProgress)}
        className="search-class"
        placeholder={props.placeholder}
        onChange={props.onChange}
        value={value}
        style={props.style}
      />
    );
  } else {
    return (
      <FormControl
        ref={props.autoFocus ? afInput : undefined}
        autoFocus={props.autoFocus}
        plaintext={props.plaintext}
        readOnly={props.readOnly}
        title={props.title}
        placeholder={props.placeholder}
        required={props.required || isRequired}
        type={props.type}
        value={props.value || ""}
        onChange={props.onChange}
        disabled={
          disableable &&
          (props.disabled || inProgress || !userHasAnyOfProcessesOrSameParty)
        }
        isValid={isValid}
        isInvalid={isInvalid}
        as={props.as}
        rows={props.rows}
        maxLength={props.maxLength}
        onDoubleClick={props.onDoubleClick}
      />
    );
  }
};

SubmitControl.defaultProps = {
  disabled: false,
  required: false,
  valid: undefined
};

export default SubmitControl;
